import { ConnectionPointDto } from '@app/api/nts';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

export const connectionpointSharedInstallationMasterdata: Columns<ConnectionPointDto>[] = [
  {
    title: 'connectionpoint.sharedInstallation.hasSharedServiceLine',
    key: 'hasSharedServiceLine',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: { true: 'common.yes', false: 'common.no' },
  },
  {
    title: 'connectionpoint.sharedInstallation.hasCollectiveMetering',
    key: 'hasCollectiveMetering',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: { true: 'common.yes', false: 'common.no' },
  },
  {
    title: 'connectionpoint.sharedInstallation.numberOfInstallations',
    key: 'numberOfInstallations',
  },
  {
    title: 'connectionpoint.sharedInstallation.categoryOfInstallations',
    key: 'categoryOfInstallations.name',
  },
];
